import {Mesh, PlaneGeometry, ShadowMaterial} from 'three'

import {GROUND_SIZE_M, SHADOW_OPACITY} from '../config'

export type GroundPlane = Mesh<PlaneGeometry, ShadowMaterial>

/**
 * An invisible plane at y = 0 that serves as the raycast fallback when
 * `XR8.XrController.hitTest()` returns nothing - which it always does until
 * SLAM has gathered enough feature points. Without this, the first few taps
 * after the camera opens would silently do nothing.
 *
 * It does not catch shadows: the shadow catcher is parented to the placed model
 * instead, so the contact shadow can never drift away from the model's feet.
 */
export const createGroundPlane = (): GroundPlane => {
  const mesh = new Mesh(
    new PlaneGeometry(GROUND_SIZE_M, GROUND_SIZE_M),
    new ShadowMaterial({opacity: SHADOW_OPACITY})
  )
  mesh.name = 'ground-fallback'
  mesh.rotation.x = -Math.PI / 2
  mesh.position.y = 0
  mesh.visible = false
  return mesh
}
